<template>
  <div class="meta-format-explain">
    <div class="meta-format-title">
      显示格式中的替换变量说明
       <el-popover
        placement="top"
        title=""
        width="290"
        trigger="hover"
        popper-class='detail-popper'
        content="如果您修改现有字段的“显示格式”，只会影响在更新日期之后创建的记录。">
        <el-button class="defaultColor" type='text' slot="reference" icon='el-icon-question'></el-button>
      </el-popover>
    </div>
    <el-table
      :data="getExplainTableData"
      border
      :header-row-class-name="'table-header'"
      class="meta-format-table"
      style="width: 100%;">
      <el-table-column
        prop="key1"
        width="70"
      >
      </el-table-column>
      <el-table-column
        prop="key2"
        width='72'
      >
      </el-table-column>
      <el-table-column
        prop="key3"
        width='50'>
      </el-table-column>
      <el-table-column
              prop="key4">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  props: {
    dynamicData: Array
  },
  data() {
    return {
      explainTableData: [
        {
          key1: '序列编号',
          key2: '{0}',
          key3: '必需',
          key4: '包括花括号中的一个或多个零代表序列编号本身。花括号中零的个数表示将显示的最小数字位数。如果实际编号的位数小于此数，将在其前边置零。最大位数为10位。'
        },
        {
          key1: '年份',
          key2: '{YY} {YYYY}',
          key3: '可选',
          key4: '包括花括号中的两个或四个“Y”字符，代表记录创建日期的年份。您可以显示年份的两位 (如“04”) 或全部的四位 (如“2004”) 。'
        },
        {
          key1: '月份',
          key2: '{MM}',
          key3: '可选',
          key4: '包括在花括号中的两位字符表示记录创建日期的月份数字 (如“01”表示一月，“02”表示二月) 。'
        },
        {
          key1: '日期',
          key2: '{DD}',
          key3: '可选',
          key4: '包括在花括号中的两位字符表示记录创建日期的日期数字 (如“01”至“31”都是一月的有效日期) 。'
        },
        {
          key1: '时',
          key2: '{HH}',
          key3: '可选',
          key4: '包括在花括号中的两位字符表示记录创建时间的小时数字(如“01”到“24”都是一天的有效小时)。'
        },
        {
          key1: '分',
          key2: '{mm}',
          key3: '可选',
          key4: '包括在花括号中的两位字符表示记录创建时间的分钟数字(如“01”到“60”都是一小时内的有效分钟数)。'
        },
        {
          key1: '秒',
          key2: '{ss}',
          key3: '可选',
          key4: '包括在花括号中的两位字符表示记录创建时间的秒的数字(如“01”到“60”都是一分钟内的有效秒数)。'
        }
      ],
      department: {
        key1: '',
        key2: '',
        key3: '可选',
        key4: '部门字段，将该数据的此字段对应的编号赋值到自动编号。'
      },
      select_one: {
        key1: '',
        key2: '',
        key3: '可选',
        key4: '单选字段，将该数据的此字段对应的编号赋值到自动编号。'
      }
    }
  },
  computed: {
    getExplainTableData() {
      let dynamicData = this.dynamicData.reduce((pre, item) => {
        pre.push(item.type === 'department' ? Object.assign({}, this.department, { key1: item.apiName }) : Object.assign({}, this.select_one, { key1: item.apiName }));
        return pre;
      }, [])

      return [].concat(this.explainTableData, dynamicData);
    }
  }
}
</script>

<style lang='scss'>
.meta-format-explain {
  font-size: 12px;
  color: #979ba8;
  line-height: 18px;

  .meta-format-title {
    height: 34px;
  }

  .meta-format-table {
    .table-header {
      display: none;
    }

    .cell {
      color: #979ba8;
      font-size: 12px;
      user-select: text;
    }
  }

  .defaultColor {
    color: #9094a3 !important;
  }
}
</style>